<template>
  <MobileMenu :unread-message-count="unreadMessageCount">
    <template #bottom v-if="showCredits">
      <div
        class="text-secondary-700 text-right p-4 py-3 border-t border-secondary-200"
        aria-label="credits remaining"
      >
        <div class="text-xs">Credits remaining:</div>
        <div class="text-lg font-bold">{{ creditsRemaining }}</div>
      </div>
    </template>
  </MobileMenu>
  <DesktopMenu :unread-message-count="unreadMessageCount">
    <template #bottom v-if="showCredits">
      <div
        class="text-secondary-500 text-left border-t border-secondary-200 p-4 py-3"
        aria-label="credits remaining"
      >
        <div class="text-xs">Credits remaining:</div>
        <div class="text-lg font-bold">{{ creditsRemaining }}</div>
      </div>
    </template>
  </DesktopMenu>
</template>

<script lang="ts" setup>
import DesktopMenu from "@/components/menu/desktop-menu/desktop-menu.vue";
import MobileMenu from "@/components/menu/mobile-menu/mobile-menu.vue";
import { messagesLogEventsService } from "@/services/messages.service";
import { ref, onMounted, inject, computed, onUnmounted } from "vue";
import { useCreditUsageStore } from "@/pinia/useCreditUsageStore";
import { storeToRefs } from "pinia";
import { useUserAccountsStore } from "@/pinia/useUserAccountsStore";
import usePolling from "@/helpers/polling";

const unreadMessageCount = ref(0);
const emitter: any = inject("emitter");
const { setSmsCreditsCount } = useCreditUsageStore();
const { getSmsCreditsCount } = storeToRefs(useCreditUsageStore());
const { getUserProfile } = storeToRefs(useUserAccountsStore());
const { resetPolling, executePolling } = usePolling();

emitter.on("decrease-unread-message-count", () => {
  unreadMessageCount.value = unreadMessageCount.value - 1;
});

emitter.on("increase-unread-message-count", () => {
  unreadMessageCount.value = unreadMessageCount.value + 1;
});

emitter.on("unread-message-count", (count: number) => {
  unreadMessageCount.value = count;
});

const creditsRemaining: any = getSmsCreditsCount;

const showCredits = computed(
  () =>
    getUserProfile.value?.roles?.includes("BILLING") ||
    getUserProfile.value?.inheritCredits,
);

onMounted(async () => {
  await setSmsCreditsCount();
  let { data: count } =
    await messagesLogEventsService.getAcknowledgedInbounds();
  unreadMessageCount.value = count;
  executePolling(setSmsCreditsCount, 30000);
});

onUnmounted(() => {
  resetPolling();
});
</script>
